import { render, staticRenderFns } from "./CR2000.vue?vue&type=template&id=51447ea6"
import script from "./CR2000.vue?vue&type=script&lang=js"
export * from "./CR2000.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports